import { isMobile } from 'react-device-detect'

const getResponsiveModalWidth = (width: number | string): number | string => (
  isMobile ? "90%" : width 
)

export { getResponsiveModalWidth }